import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6024308a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "map" }

import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
import { addMapLayer, mapboxConfig, removeMapLayer } from '@/utils/mapbox';
import { onMounted, onUnmounted, ref } from 'vue';
import { eventBus, useLayers } from '@/states/layerStats';
import { LayerMenuItemConfig } from '@/typings/layer';

export type DrawTool = 'circle' | 'rectangle' | 'polygon';


export default /*#__PURE__*/_defineComponent({
  __name: 'Map',
  setup(__props, { expose }) {

const { toggleLayer } = useLayers();

const map = ref<mapboxgl.Map>();

const onLayerAdded = (e: LayerMenuItemConfig) => {
  addMapLayer(map.value, e);
};

const onLayerRemoved = (e: LayerMenuItemConfig) => {
  removeMapLayer(map.value, e.layers);
};

onMounted(() => {
  eventBus.on('layer-added', onLayerAdded);
  eventBus.on('layer-removed', onLayerRemoved);

  // initializing mapbox
  map.value = new mapboxgl.Map(mapboxConfig);
  map.value.touchZoomRotate.disableRotation();
  // This prevent the 'Mapbox GL JS: Style is not done loading' error
  // on adding layer in the starting
  const onStyleDataLoaded = () => {
    if (map.value.isStyleLoaded()) {
      // toggling on layers that will be visible be default
      toggleLayer([
        // global
        'nd_near_airport_5miles_46324',
        'special_use_airspace_risk',
        'nd_urban_area',
        'nd_nuclear_buffered_800m',
        // india
        'buffer3km_ss',
        'wls_parks',
        'merge25kmintboundary',
        'new5kmbuffer',
        'buffer_8km',
        'newbuffer12km',
        'redzone_india',
      ]);

      map.value.off('styledata', onStyleDataLoaded);
    }
  };
  map.value.on('styledata', onStyleDataLoaded);
});

onUnmounted(() => {
  eventBus.removeListener('layer-added', onLayerAdded);
  eventBus.removeListener('layer-removed', onLayerRemoved);
});

expose({ map });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})